import React from "react";
import { HashRouter  as Router, Routes, Route, Link } from "react-router-dom";
import "../CSS/NavBar.css";
import designerImage from "../Resources/Images/G.png";



const Navbar: React.FC = () => {
  return (
    <nav>
      <div className="nav">
      {/* <img className="designerImage" src={designerImage} alt="Designer" /> */}
      <p>GeraldFernand0</p>
        <div className="navigationSection">
          <ul className="navigationSectionList">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/About">About</Link></li>
            <li><Link to="/Contact">Contact</Link></li>
          </ul>
        </div>
      </div>
      
    </nav>
  );
};
export default Navbar;